import React from "react";
import Header from "./components/Header";
import MapSection from "./components/MapSection";
import ShowroomInfo from "./components/ShowroomInfo";
import Footer from "./components/Footer";
import GoogleMapsLoader from "./utils/GoogleMapsLoader";
import { fetchMyMapsShowrooms } from "./services/myMapsKml";
import "./styles/App.css";

// Danh sách trạm dịch vụ
const fallbackShowrooms = [
  {
    name: "Mai Anh",
    lat: 21.942354,
    lng: 106.703097,
    address: "QL 1A - Huyện Cao Lộc - Lạng Sơn ( Gần cửa khẩu Hữu Nghị)",
    phone: "0387322699"
  },
  {
    name: "Công Ty Hùng Phong",
    lat: 21.02981,
    lng: 105.93271,
    address: "66 Nguyễn Đức Thuận - P Thạch Bàn - Long Biên - Hà Nội",
    phone: "0989343648"
  },
  {
    name: "Máy phát điện Duy Tánh",
    lat: 19.691682,
    lng: 105.786754,
    address: "442, QL1A, Thôn Ninh Phạm, Xã Quảng Ninh, huyện Quảng Xương, Thanh Hóa.​",
    phone: "0978078626"
  },
  {
    name: "Quỳnh garage",
    lat: 17.2063,
    lng: 106.8696,
    address: "Thôn Phù Lưu, Hưng Thủy-Lệ Thủy-Tỉnh Quảng Bình",
    phone: "0353359379"
  },
  {
    name: "Garage Văn Hùng",
    lat: 16.407756,
    lng: 107.559566,
    address: "Đường tránh Huế, Hương Thọ, Huế, Thừa Thiên Huế",
    phone: "0852627142"
  },
  {
    name: "Cơ khí Toàn Phát",
    lat: 10.9203,
    lng: 107.9938,
    address: "KM13, Thôn Dân Hiệp, Xã Hàm Kiệm, Bình Thuận, Việt Nam",
    phone: "0965922511"
  },
  {
    name: "Gara Tiến An",
    lat: 10.361,
    lng: 106.3406,
    address: "157C NGUYỄN THỊ THẬP, PHƯỜNG 5, TP. MỸ THO, TIỀN GIANG",
    phone: "0916674399"
  },
  {
    name: "Công ty TNHH MTV Tâm Bình",
    lat: 20.941873464250744,
    lng: 105.84426096009676,
    address: "577 Đ. Ngọc Hồi, Văn Điển, Thanh Trì, Hà Nội, Việt Nam",
    phone: "0329990912"
  },
  {
    name: "Công ty TNHH MTV Hồng Hải Bình",
    lat: 15.91784266,
    lng: 108.2348177,
    address: "W69M+2WG, Khối phố Phong Nhị, Điện Bàn, Quảng Nam, Việt Nam",
    phone: "0905107467"
  },
  {
    name: "Công ty TNHH MTV Gia Bình",
    lat: 12.63912985,
    lng: 108.0078467,
    address: "192 Võ Văn Kiệt, Khánh Xuân, Buôn Ma Thuột, Đắk Lắk 630000, Việt Nam",
    phone: "0911450969"
  },
  {
    name: "Công ty TNHH MTV An Khánh Bình",
    lat: 10.90842196,
    lng: 107.23396,
    address: "170 QL1A, Xuân Tân, Long Khánh, Đồng Nai, Việt Nam",
    phone: " 0903843188"
  },
  {
    name: "Công ty TNHH MTV An Kiên Bình",
    lat: 10.827027605300827,
    lng: 105.92133960016423,
    address: "RWGC+GHM, TL831, Bình Hiệp, Kiến Tường, Long An, Việt Nam",
    phone: "(0272)3952539"
  },
  {
    name: "Công ty TNHH MTV Long Bình",
    lat: 10.43619896,
    lng: 105.0243616,
    address: "75 TL941, TT. Tri Tôn, Tri Tôn, An Giang, Việt Nam",
    phone: "0962595900"
  },
  {
    name: "Công ty Cổ Phần Công Nghiệp Kim Bình",
    lat: 10.73634377,
    lng: 106.5881605,
    address: "Lô 16 Trung Tâm, KCN, Bình Tân, Hồ Chí Minh 70000, Việt Nam",
    phone: "1800646478"
  },
  {
    name: "Ô Tô Quang Hưng",
    lat: 20.846944444444443,
    lng: 106.73777777777778,
    address: "Số 29/55 Bùi Thị Từ Nhiên, Phường Đông Hải 1, Quận Hải An, Thành phố Hải Phòng, Việt Nam",
    phone: "0936128028"
  },
  {
    name: "Công ty TNHH Máy và Thiết Bị Minh Triết",
    lat: 12.2333943,
    lng: 109.0903692,
    address: "2 QL1A, thôn Cư Thạnh, Diên Khánh, Khánh Hòa 57000, Việt Nam",
    phone: "0913399434"
  },
  {
    name: "Garage Hai Lúa",
    lat: 14.214806,
    lng: 109.063694,
    address: "Đèo Cù Mông, xã Xuân Lộc, tỉnh Đắk Lắk",
    phone: "0974445255"
  },
  {
    name: "Khôi Tuy Hoà",
    lat: 12.99652778,
    lng: 109.26613889,
    address: "Nút giao QL29 và Cao tốc Vân Phong-Chí Thạnh, xã Tây Hoà, tỉnh Đắk Lắk",
    phone: "0385698507"
  }
];

// Hàm tính khoảng cách giữa hai điểm trên mặt đất (Haversine formula)
// Sử dụng làm phương án dự phòng nếu API không hoạt động
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Bán kính trái đất tính bằng km
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

const toRadians = (degree) => {
  return degree * (Math.PI / 180);
};

// Hàm tính khoảng cách thực tế sử dụng Google Distance Matrix API
const calculateRealDistance = async (origin, destinations) => {
  return new Promise((resolve, reject) => {
    try {
      // Kiểm tra nếu Google Maps API đã được tải
      if (!window.google || !window.google.maps) {
        // Nếu chưa được tải, sử dụng phương pháp dự phòng
        console.log(
          "Google Maps API chưa được tải, sử dụng phương pháp dự phòng",
        );
        const fallbackResults = destinations.map((dest) => {
          const distance = calculateDistance(
            origin.lat,
            origin.lng,
            dest.lat,
            dest.lng,
          );

          // Ước tính thời gian di chuyển (giả định tốc độ trung bình 50 km/h)
          const timeInHours = distance / 50;
          const hours = Math.floor(timeInHours);
          const minutes = Math.round((timeInHours - hours) * 60);

          let durationText;
          if (hours > 0) {
            durationText = `${hours} giờ ${minutes} phút`;
          } else {
            durationText = `${minutes} phút`;
          }

          // Thêm 20% cho khoảng cách thực tế (ước tính)
          const realDistance = distance * 1.2;

          return {
            status: "OK",
            distance: {
              value: realDistance * 1000, // Chuyển sang mét
              text: `${Math.round(realDistance * 10) / 10} km`,
            },
            duration: {
              value: timeInHours * 3600, // Chuyển sang giây
              text: durationText,
            },
          };
        });

        resolve(fallbackResults);
        return;
      }

      // Sử dụng Distance Matrix API của Google Maps
      const service = new window.google.maps.DistanceMatrixService();

      // Chuẩn bị mảng điểm đến
      const destinationPoints = destinations.map(
        (dest) => new window.google.maps.LatLng(dest.lat, dest.lng),
      );

      // Tạo yêu cầu
      const request = {
        origins: [new window.google.maps.LatLng(origin.lat, origin.lng)],
        destinations: destinationPoints,
        travelMode: "DRIVING",
        unitSystem: window.google.maps.UnitSystem.METRIC,
        avoidHighways: false,
        avoidTolls: false,
      };

      // Gọi API
      service.getDistanceMatrix(request, (response, status) => {
        if (status === "OK") {
          // Xử lý kết quả từ API
          const results = [];

          if (response.rows && response.rows.length > 0) {
            const elements = response.rows[0].elements;

            elements.forEach((element, index) => {
              if (element.status === "OK") {
                results.push({
                  status: "OK",
                  distance: {
                    value: element.distance.value,
                    text: element.distance.text,
                  },
                  duration: {
                    value: element.duration.value,
                    text: element.duration.text,
                  },
                });
              } else {
                // Nếu không lấy được kết quả từ API cho điểm đến cụ thể, sử dụng phương pháp dự phòng
                const distance = calculateDistance(
                  origin.lat,
                  origin.lng,
                  destinations[index].lat,
                  destinations[index].lng,
                );

                const timeInHours = distance / 50;
                const hours = Math.floor(timeInHours);
                const minutes = Math.round((timeInHours - hours) * 60);

                let durationText;
                if (hours > 0) {
                  durationText = `${hours} giờ ${minutes} phút`;
                } else {
                  durationText = `${minutes} phút`;
                }

                results.push({
                  status: "FALLBACK",
                  distance: {
                    value: distance * 1000,
                    text: `${Math.round(distance * 10) / 10} km`,
                  },
                  duration: {
                    value: timeInHours * 3600,
                    text: durationText,
                  },
                });
              }
            });

            resolve(results);
          } else {
            throw new Error("Không nhận được kết quả từ Distance Matrix API");
          }
        } else {
          throw new Error(`Lỗi Distance Matrix API: ${status}`);
        }
      });
    } catch (error) {
      console.error("Lỗi khi tính khoảng cách:", error);
      reject(error);
    }
  });
};

function App() {
  const [showrooms, setShowrooms] = React.useState(fallbackShowrooms);
  // eslint-disable-next-line no-unused-vars
  const [userLocation, setUserLocation] = React.useState(null);
  // eslint-disable-next-line no-unused-vars
  const [nearestShowroom, setNearestShowroom] = React.useState(null);
  const [sortedShowrooms, setSortedShowrooms] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [travelInfo, setTravelInfo] = React.useState([]);
  const [apiError, setApiError] = React.useState(false);
  const [mapsApiLoaded, setMapsApiLoaded] = React.useState(false);

  // Load danh sach tram dich vu tu Google My Maps KML
  React.useEffect(() => {
    let isMounted = true;

    const loadShowroomsFromMap = async () => {
      try {
        const kmlShowrooms = await fetchMyMapsShowrooms(fallbackShowrooms);

        if (isMounted && kmlShowrooms.length > 0) {
          setShowrooms(kmlShowrooms);
          setSortedShowrooms([]);
          setTravelInfo([]);
        }
      } catch (error) {
        console.error("Khong the tai danh sach tram dich vu tu KML:", error);
      }
    };

    loadShowroomsFromMap();

    return () => {
      isMounted = false;
    };
  }, []);

  // Xử lý khi Google Maps API được tải thành công
  const handleGoogleMapsLoaded = () => {
    console.log("Google Maps API đã được tải thành công");
    setMapsApiLoaded(true);
  };

  // Xử lý khi có lỗi tải Google Maps API
  const handleGoogleMapsError = (error) => {
    console.error("Lỗi khi tải Google Maps API:", error);
    setApiError(true);
  };

  const findNearestShowroom = async () => {
    setLoading(true);
    setError(null);
    setApiError(false);

    try {
      // Lấy vị trí người dùng
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            const userLoc = { lat: latitude, lng: longitude };
            setUserLocation(userLoc);

            try {
              // Sử dụng Distance Matrix API nếu đã tải thành công
              const distanceResults = await calculateRealDistance(
                userLoc,
                showrooms,
              );

              if (distanceResults && distanceResults.length > 0) {
                // Tính khoảng cách và sắp xếp showrooms dựa trên kết quả
                const distances = showrooms.map((showroom, index) => {
                  const result = distanceResults[index];
                  let distance = 0;
                  let duration = "";
                  let isRealDistance = false;

                  if (result.status === "OK") {
                    distance = result.distance.value / 1000; // Chuyển từ mét sang km
                    duration = result.duration.text;
                    isRealDistance = true;
                  } else {
                    // Sử dụng phương pháp dự phòng nếu không có kết quả
                    distance = calculateDistance(
                      latitude,
                      longitude,
                      showroom.lat,
                      showroom.lng,
                    );
                  }

                  return {
                    ...showroom,
                    distance: Math.round(distance * 100) / 100, // Làm tròn đến 2 chữ số thập phân
                    duration:
                      result.status === "OK" ? duration : "Không có dữ liệu",
                    realDistance: isRealDistance,
                  };
                });

                // Sắp xếp trạm dịch vụ theo khoảng cách từ gần đến xa
                const sorted = [...distances].sort(
                  (a, b) => a.distance - b.distance,
                );

                // Lưu danh sách đã sắp xếp
                setSortedShowrooms(sorted);

                // Lấy trạm dịch vụ gần nhất (phần tử đầu tiên sau khi sắp xếp)
                setNearestShowroom(sorted[0]);
                setTravelInfo(distances);

                // Kiểm tra xem có sử dụng phương pháp dự phòng không
                const usingFallback = distances.some(
                  (item) => !item.realDistance,
                );
                setApiError(usingFallback);
              } else {
                throw new Error("Không thể tính toán khoảng cách");
              }
            } catch (apiErr) {
              console.error(
                "Lỗi khi tính toán khoảng cách, sử dụng phương pháp dự phòng:",
                apiErr,
              );
              setApiError(true);

              // Sử dụng phương pháp dự phòng (Haversine formula)
              const distances = showrooms.map((showroom) => {
                const distance = calculateDistance(
                  latitude,
                  longitude,
                  showroom.lat,
                  showroom.lng,
                );
                return {
                  ...showroom,
                  distance: Math.round(distance * 100) / 100, // Làm tròn đến 2 chữ số thập phân
                  duration: "Không có dữ liệu",
                  realDistance: false,
                };
              });

              // Sắp xếp trạm dịch vụ theo khoảng cách từ gần đến xa
              const sorted = [...distances].sort(
                (a, b) => a.distance - b.distance,
              );

              // Lưu danh sách đã sắp xếp
              setSortedShowrooms(sorted);

              // Lấy trạm dịch vụ gần nhất (phần tử đầu tiên sau khi sắp xếp)
              setNearestShowroom(sorted[0]);
              setTravelInfo(distances);
            }

            setLoading(false);
          },
          (error) => {
            setError(
              "Không thể lấy vị trí của bạn. Vui lòng cho phép truy cập vị trí.",
            );
            setLoading(false);
          },
        );
      } else {
        setError("Trình duyệt của bạn không hỗ trợ Geolocation");
        setLoading(false);
      }
    } catch (err) {
      setError("Đã xảy ra lỗi khi tìm trạm dịch vụ: " + err.message);
      setLoading(false);
    }
  };

  console.log("Version 1.6.0");

  return (
    <div
      className="app"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/Background-Service-Station.webp)`,
      }}
    >
      <GoogleMapsLoader
        onLoad={handleGoogleMapsLoaded}
        onError={handleGoogleMapsError}
      />
      <Header />
      <main>
        <div className="content-wrapper">
          <h2 className="section-title">HỆ THỐNG TRẠM DỊCH VỤ BẢO HÀNH</h2>
          {apiError && (
            <div className="notice-message">
              Đang sử dụng phương pháp tính khoảng cách dự đoán thay vì khoảng
              cách thực tế
            </div>
          )}
          <div className="showroom-container">
            <div className="map-wrapper">
              <MapSection
                onFindNearest={findNearestShowroom}
                loading={loading}
                mapsApiLoaded={mapsApiLoaded}
              />
            </div>
            <div className="info-wrapper">
              {error ? (
                <div className="error-message">{error}</div>
              ) : (
                <ShowroomInfo
                  showroom={null}
                  allShowrooms={
                    sortedShowrooms.length > 0 ? sortedShowrooms : showrooms
                  }
                  travelInfo={travelInfo}
                />
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default App;
